/*
 * Automatically generated by SVGR from assets/icons/*.svg.
 * Do not edit this file or add other components to this directory.
 */
import type { SVGProps } from 'react'
export function ExclamationCircleOutlineIcon(
  props: SVGProps<SVGSVGElement>
): JSX.Element {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='1em'
      height='1em'
      fill='none'
      viewBox='0 0 24 25'
      {...props}
    >
      <mask
        id='exclamation-circle-outline_svg__a'
        width={24}
        height={25}
        x={0}
        y={0}
        maskUnits='userSpaceOnUse'
        style={{
          maskType: 'alpha',
        }}
      >
        <path fill='#D9D9D9' d='M0 .018h24v24H0z' />
      </mask>
      <g mask='url(#exclamation-circle-outline_svg__a)'>
        <path
          fill='#E36857'
          d='M12 17.018a.97.97 0 0 0 .713-.288.97.97 0 0 0 .287-.712.97.97 0 0 0-.287-.713.97.97 0 0 0-.713-.287.97.97 0 0 0-.712.287.97.97 0 0 0-.288.713q0 .424.288.712a.97.97 0 0 0 .712.288m-1-4h2v-6h-2zm1 9a9.7 9.7 0 0 1-3.9-.788 10.1 10.1 0 0 1-3.175-2.137q-1.35-1.35-2.137-3.175a9.7 9.7 0 0 1-.788-3.9q0-2.076.788-3.9a10.1 10.1 0 0 1 2.137-3.175q1.35-1.35 3.175-2.138a9.7 9.7 0 0 1 3.9-.787q2.075 0 3.9.787a10.1 10.1 0 0 1 3.175 2.138q1.35 1.35 2.137 3.175a9.7 9.7 0 0 1 .788 3.9 9.7 9.7 0 0 1-.788 3.9 10.1 10.1 0 0 1-2.137 3.175q-1.35 1.35-3.175 2.137a9.7 9.7 0 0 1-3.9.788m0-2q3.35 0 5.675-2.325T20 12.018t-2.325-5.675T12 4.018 6.325 6.343 4 12.018t2.325 5.675T12 20.018'
        />
      </g>
    </svg>
  )
}
